import React from 'react';
import { FadeIn } from './FadeIn';
export function BeforeAfter() {
  return <section className="py-8 px-3" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <FadeIn className="text-center mb-6" data-id="element-17">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-18">
            Sistema Clínico Nutricional{' '}
            <span className="text-accent" data-id="element-19">Completo</span>
          </h2>
          <p className="text-white/60 text-sm md:text-base max-w-xl mx-auto mb-4" data-id="element-20">
            Todo lo que necesitás para evaluar, intervenir y hacer seguimiento
            sin perder horas ni dudar en consulta.
          </p>
          <div className="inline-flex items-center gap-2 md:gap-3 bg-accent/10 border border-accent/20 rounded-full px-5 py-2" data-id="element-21">
            <span className="text-accent font-bold text-sm md:text-base" data-id="element-22">
              Abrís
            </span>
            <span className="text-accent/40 text-lg" data-id="element-23">·</span>
            <span className="text-accent font-bold text-sm md:text-base" data-id="element-24">
              Aplicás
            </span>
            <span className="text-accent/40 text-lg" data-id="element-25">·</span>
            <span className="text-accent font-bold text-sm md:text-base" data-id="element-26">
              Resolvés
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}